module.exports = __webpack_public_path__ + "img/newsImg3-1.405a34da.png";